import { appColorsDark } from './dark';
import { appColorsLight } from './light';
import type { AppColors } from './types';

export { appColorsLight, appColorsDark };
export type { AppColors };

export const getAppColors = (mode: 'light' | 'dark'): AppColors =>
  mode === 'dark' ? appColorsDark : appColorsLight;
